import { atom } from 'recoil';

export const useSubjectNotice = atom({
  key: 'useSubjectNotice',
  default: [],
});
